window.$ = window.jQuery = require('jquery');
window.Popper = require('popper.js');
require('bootstrap');
window.ApexCharts = require('apexcharts');
// require('./scrollbar');
// window.beautify = require('./beautify');
window.Swal = require('sweetalert2/dist/sweetalert2.js');
// window.feather = require('feather-icons');
// window.toastr = require('toastr');

require('leaflet')

window.beautify = require('./beautify');
window.mdtimepicker = require('@dmuy/timepicker');
moment = require('moment')
require('bootstrap4-toggle');
require('bootstrap-datepicker');
require('bootstrap-daterangepicker');
require('bootstrap-autocomplete');
// require('summernote/dist/summernote-bs4');
require('select2');
require('datatables.net');
require('datatables.net-bs4');
require('datatables.net-buttons');
require('datatables.net-buttons-bs4');

require('./firebase-init');

require('block-ui');

// const JSZip = require('jszip');
const pdfMake = require('pdfmake');
require( 'datatables.net-buttons/js/buttons.colVis.js' );
require( 'datatables.net-buttons/js//buttons.html5.js' );
require( 'datatables.net-buttons/js/buttons.print.js' );

require('smartwizard')




require('./uploader');
require('dropzone');
// require('jquery.qrcode');

require('./ajax');
require('./functions');
require('./increment-select');
require('./rating');
require('./json-slider');
require('./div-radio');
require('./products-intl')

window.intlTelInput = require("intl-tel-input");
require("intl-tel-input/build/css/intlTelInput.css");

require('./initializer');
require('./custom-script');
require('./stripe-init');
require('./address-picker');
require('./order-wizard');
